import { Roles } from "../constants/roles";
import { bindRoleClick } from "../util/tabs/tabs-listener";
import type { HomeRankingProductTabsForm } from "./home-ranking-product-tabs-form";
import type { HomeRankingProductTabsHandler } from "./home-ranking-product-tabs-handler";

export class HomeRankingProductTabsListener {
    private readonly form: HomeRankingProductTabsForm;

    private readonly handler: HomeRankingProductTabsHandler;

    public constructor(form: HomeRankingProductTabsForm, handler: HomeRankingProductTabsHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        bindRoleClick(this.form.getRoot(), Roles.HOME_RANKING_PRODUCT_TAB, (event, element) => {
            this.handler.handleTabClick(event, element.dataset.parentCategoryId);
        });
    }
}
